export const BELOW = -1
export const NEUTRAL = 0
export const ABOVE = 1
export const HIGH = 100

export const FOOTER = HIGH - 1
export const HEADER = 300
export const TOAST = 500
export const MODAL = 900
